<template>
  <SearchNavBar
    v-model:value="query.goods_name"
    @onSearch="init"
  />
  <div class="content">
    <HeaderTitle
      plain
      title="搜索结果"
    >
      <template #right>
        <span @click="$router.push('/category')">查看全部内容</span>
      </template>
    </HeaderTitle>

    <CellCardList :data="goodsList" />
    <div class="bottom">
      <van-loading
        v-show="loading"
        size="18px"
      >加载中...</van-loading>
      <div
        class="none"
        v-show="!goodsList.length && !loading"
      >
        暂无“{{noneText}}”的相关内容，请更换关键词试试
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted } from "vue";
import { useRoute } from "vue-router";
import SearchNavBar from "@/components/SearchNavBar";
import HeaderTitle from "@/components/HeaderTitle";
import CellCardList from "@/components/CellCardList";
import { getGoodsList } from "@/api/category";

export default {
  name: "search",
  components: {
    SearchNavBar,
    HeaderTitle,
    CellCardList,
  },
  setup() {
    const route = useRoute();
    const state = reactive({
      goodsList: [],
      loading: false,
      noneText: "",
      query: {
        goods_category_id: 0,
        limit: 20,
        page: 1,
        goods_name: "",
        sort_type: 1,
      },
    });
    onMounted(() => {
      const { keywords } = route.query;
      if (keywords) {
        state.query.goods_name = keywords;
        init();
      }
    });

    async function init() {
      state.loading = true;
      const { data } = await getGoodsList(state.query);
      state.loading = false;
      if (!data.data.length) {
        state.noneText = state.query.goods_name;
      }
      state.goodsList = data.data;
    }

    return {
      init,
      ...toRefs(state),
    };
  },
};
</script>

<style lang="less" scoped>
.content {
  padding: 0 @padding-base @padding-base @padding-base;
}
.none-result {
  text-align: center;
  padding: @padding-base;
  color: @gray-color;
  font-size: @font-size-base;
}
.bottom {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: @padding-sm;
  .none {
    color: #969799;
    font-size: @font-size-base;
  }
}
</style>